import con from '../../../../../../connection';
var path = '/download';
var download = function (url) { return function () { return ({
    get: function (authId) { return con.getFile(url + "/" + authId + path, {}, false, 30000, true); },
}); }; };
export default download;
